import ToggleComponent from "components/atoms/toggle/Toggle";
import * as s from "./NotificationStyle";
import { useNotification } from "./NotificationContainer";
import ReadIcon from "assets/icons/read.svg";

//알림 드랍다운 헤더 컴포넌트
const NotificationHeader = () => {
  const {
    isUnReadOnly,
    setIsUnReadOnly,
    isSettingOpen,
    setIsSettingOpen,
    onChangeAllRead,
    notificationSettingRef,
  } = useNotification();

  return (
    <s.NotificationTitle>
      <h3>Notifications</h3>
      <s.NotificationButtonWrapper>
        <s.NotificationSortButton>
          <label
            onClick={() => setIsUnReadOnly(!isUnReadOnly)}
            data-testid="blocks-headernav-notification-label-unread-only-toggle"
          >
            Unread Only
          </label>
          <ToggleComponent
            label=" "
            isToggled={isUnReadOnly}
            onChange={(checked) => setIsUnReadOnly(checked)}
            size="small"
          />
        </s.NotificationSortButton>
        <s.NotificationSettingButton
          onClick={(e) => {
            setIsSettingOpen(!isSettingOpen);
          }}
          data-testid="blocks-headernav-notification-button-setting-open"
        >
          <span></span>
        </s.NotificationSettingButton>
      </s.NotificationButtonWrapper>
      {isSettingOpen && (
        <s.NotificationSettingWrapper
          ref={notificationSettingRef}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
              onChangeAllRead();
            }}
            data-testid="blocks-headernav-notification-button-mark-all-as-read"
          >
            <img src={ReadIcon} alt="" /> <span>Mark All As Read</span>
          </button>
        </s.NotificationSettingWrapper>
      )}
    </s.NotificationTitle>
  );
};

export default NotificationHeader;
